<template>
	<div class="books">
		<div class="list">
			<div class="list-div" v-for="(item,index) in list" :key="index">
				<div class="title">{{item.name}}</div>
				<div class="connet">
					<div class="left">
						<img :src="item.img" />
					</div>
					<div class="right">
						<div class="right-div">{{item.brief}}</div>
						<div class="right-div1">
							<div>购买链接：</div>
							<a :href="item.dang_url">
								<img src="../../assets/shudo/images/dang.png" />
							</a>
							<a :href="item.jin_url">
								<img src="../../assets/shudo/images/jing.png">
							</a>
							<a :href="item.tao_url">
								<img src="../../assets/shudo/images/tao.png" />
							</a>
							<a :href="item.mao_url">
								<img src="../../assets/shudo/images/tian.png" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				list : [],
				sponsor_id:''
			}
	    },
		created() {
			let that = this;
			var  query = that.$route.query;
			if(query.sponsor_id){
				that.sponsor_id = query.sponsor_id;
				
				that.$http('get','/api/v1/books/sponsorlist',{'sponsor_id':that.sponsor_id}) .then(function (res) {
					console.log(res);
					that.list = res.data.list;
					
				});
				
			}
		},
	
	}
</script>

<style lang="less">
	.books {
		width: 100%;
		.list {
			width: 70.5rem;
			min-height: 30rem;
			margin: auto;
			
			.list-div {
				margin: 30px;
				width: 80%;
				height: 230px;
				border-bottom: 0.0625rem solid #b0a6a6;
				background-color: #f2f2f2;
				.title {
					font-size: 1.4rem;
					height: 2.3125rem;
					box-shadow: none;
					font-family: "Arial Negreta", "Arial Normal", Arial;
					font-weight: 700;
					font-style: normal;
				}
				.connet {
					margin-top: 1.25rem;
					width: 100%;
					display: flex;
					.left {
						width: 252px;
						height: 148px;
						img {
							width: 140px;
							height: 100%;
						}
					}
					.right {
						margin-left: 0.625rem;
						.right-div {
							font-size: 1.2rem;
							height: 79px;
							width: 760px;
						  overflow: hidden;
							text-overflow: ellipsis;
							          display: -webkit-box;
							          -webkit-line-clamp: 3; //行数
							          -webkit-box-orient: vertical;
							
						}
						.right-div1 {
							font-size: 1.2rem;
							font-weight: 600;
							display: flex;
							padding: 20px;
							div {
								width: 7.5rem;
							}
							img {
								width: 5.4375rem;
								height: 2.5rem;
								margin-left: 0.625rem;
								margin-right: 0.625rem;
							}
						}
					}
					
					
				}
			}
			
		}
	}
</style>
